// ScrollToTop.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scrolla verso l'alto quando si cambia la pathname
    window.scrollTo(0, 0);

    // Aggiungi un listener per l'evento beforeunload
    const handleBeforeUnload = () => {
      // Salva la posizione corrente prima di scaricare la pagina
      sessionStorage.setItem('scrollPosition', JSON.stringify(window.scrollY));
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Pulisci il listener quando il componente si smonta
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [pathname]);

  return null; // Questo componente non rende nulla
};

export default ScrollToTop;
